import React, { useEffect, useMemo, useState } from 'react'
import BreadCrum from '../components/common/BreadCrum'
import { GOLDSTAR_ICON, GREYSTAR_ICON, PROFILE_IMG } from '../utils/aap-image-constant'
import { ROUTES } from '../hooks/routes/routes-constant';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { decryptAEStoJSON, toastEmitter } from '../utils/utilities';
import { useSelector } from 'react-redux';
import { clinicRating } from '../hooks/services/api-services';
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from '../utils/app-constants';
import TableLayout from '../components/layouts/table-layout';


const Rating = () => {
  const { t,i18n } = useTranslation();
  const navigate = useNavigate()
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [ratingData, setRatingData] = useState([]);

const payload = useMemo(() => ({
  pageIndex: page || 0,
  pageSize: pageSize || DEFAULT_PAGE_LENGTH,
  searchText: "",
  direction: sortDirection || "desc",
  filterByFieldName: sortColumn || "id",
  clinicId: userData?.id,
  doctorId: 0,
  patientId: 0,
  laguageType: i18n.language,
}), [page, pageSize, sortDirection, sortColumn, userData?.id, i18n.language]);

  const getAllRatingData = async () => {
    setPending(true);
    try {
      const response = await clinicRating(payload);
      if (response?.data?.status !== 200) {
        // toastEmitter("error", response?.data?.message);
        setRatingData([]);
      } else {
        setRatingData(response?.data?.data?.ratingResponseList);
        setTotalRows(response?.data?.data?.totalElement);
      }
    } catch (err) {
      // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };
  useEffect(() => {
    getAllRatingData();
  }, [payload]);

  const handleDataBack = () => {
    navigate(ROUTES.DASHBOARD);
  }
  const tblColumns = [
    {
      code: "S.No",
      name: t("S.No"),
      width: "200px",
      omit: false,
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      code: "patientName",
      name: t("Patient Name"),
      sortable: true,
      width: "300px",
      omit: false,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fw-600 fs-12 ">
          <div
            className="rating_content"
          >
            <img src={PROFILE_IMG} alt="img" className='p-2'  style={{
                objectFit: "cover", objectPosition: "center", width: "50px",
                height: "50px",
              }}/>
          </div>
          Anonymous
        </div>
      ),

    },
    {
      code: "rating",
      name:t("Total Rating"),
      sortable: true,
      width: "300px",
      omit: false,
      selector: (row) => {
        const rawRating = parseFloat(row?.rating) || 0;
        const rating = Math.round(rawRating); // Round to nearest whole number
        const fullStars = rating;
        const emptyStars = 5 - fullStars;

        return (
          <div className="table-cell-content d-flex align-items-center">
            {Array.from({ length: fullStars }, (_, i) => (
              <img src={GOLDSTAR_ICON} alt="star" className='me-1'/>
            ))}
            {Array.from({ length: emptyStars }, (_, i) => (
              <img src={GREYSTAR_ICON} alt="star" />
            ))}
          </div>
        );
      },
    },

    {
      code: "createdDate",
      name: t("Create Date"),
      width: "250px",
      sortable: false,
      omit: false,
      selector: (row) => (
        <div className="table-cell-content">
          {row?.createdDate?.slice(0, 10)}
        </div>
      ),
    },

  ];


  return (
    <>
      <div className="main_datatable my-lg-3 my-2 bank_tabs">
        <BreadCrum
          firstData={t("Dashboard")}
          iconshow1={true}
          secondData={t("My Rating")}
          onFirstDataClick={handleDataBack}
        />
        <div className="row gx-3 gy-3">
          <div className="table-wrapper">
            <TableLayout
              _tblColumns={tblColumns}
              _rowData={ratingData}
              pending={pending}
              pagination={true}
              selectableRows={false}
              setPending={setPending}
              _totalRows={totalRows}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              setSortColumn={setSortColumn}
              setSortDirection={setSortDirection}
            />
          </div>
         
        </div>

      </div>
    </>
  )
}

export default Rating
